import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { errorTranslationKey, ErrorType, PaymentError } from '../../common/error';

interface Props {
  error?: PaymentError;
}
// These errors are handled elsewhere
const ignoredErrors = [ErrorType.CONTRACT_VERSION_TOO_LOW, ErrorType.BRAINTREE];

export const PaymentErrorDialog = (props: Props) => {
  const { t } = useTranslation();

  const error = (props.error && !ignoredErrors.includes(props.error.errorCode)) ? props.error : undefined;
  const [isOpen, setOpen] = React.useState(!!error);

  React.useEffect(() => {
    if (error) {
      console.error('PaymentError', error);
    }
    setOpen(!!error);
  }, [error, setOpen]);

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{t('checkout.payment_failed')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{error && t(errorTranslationKey(error))}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          {t('common.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
